/*
 * @Author: 朱元培 zhuyp41266@hundsun.com
 * @Date: 2023-10-24 16:06:07
 * @LastEditors: 朱元培 zhuyp41266@hundsun.com
 * @LastEditTime: 2024-01-08 10:14:58
 * @FilePath: \jigou\src\assets\common\menu.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import store from '@/store'
let NotNeedKeepAlive = ['fundTradeBuyTrade', 'fundTradeRedeTrade']

const generateRoute = function(menuList) {
	let routeList = [
		{
	    path: '/',
	    name: 'trendsRoutes',
	    component: resolve => require(['@/view/main.vue'], resolve),
	    children: []
	  }
	]
	let routesPathList = store.getters.routesPathList;
	let routesMap = {}
	setMenu(menuList, routeList, routesPathList, routesMap)
  
	store.commit('setRoutesPathList', routesPathList);
	store.commit('setRoutesMap', routesMap);
	return routeList;
}

const setMenu = function(menuList, routeList, routesPathList, routesMap, parentName) {
	menuList.forEach((item, i) => {
		if (item.type == '1' || item.type == '2') { // type 0-分组标题类、1-页面类型、2-详情页类无菜单隐式路由、3-按钮类型
			let route = {
	      path: '',
	      component: null,
	      name: item.menuCode,
	      meta: {
	        menuCode: item.id,
	        title: item.menuName,
         	parentName: parentName ? parentName : '',
	      	type: item.type,
	      }
	    }
			// NotNeedKeepAlive.some(opt => {
			// 	if (opt === item.menuCode) {
			// 		this.$set(item.meta, 'keepAlive', false)
			// 	}
			// })
	    let URL = (item.viewUrl || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
	    URL = URL.replace(/^\//, '').replace(/_/g, '-')
      route.path = '/' + URL.replace(/\//g, '/')
      route.component = () => import(`@/view/${URL}`)
	    routeList[0].children.push(route);
	    routesPathList.push(route.path);
	    routesMap[route.name] = route.path;
		}
		if (item.viewList.length > 0) {
			setMenu(item.viewList, routeList, routesPathList, routesMap, item.menuCode);
		}
	})
}

export {
	generateRoute
}



// WEBPACK FOOTER //
// ./src/assets/common/menu.js